import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { BatchCreateChannelMembership } from "../schemas/schemas_0";
export { $Command };
export class BatchCreateChannelMembershipCommand extends $Command
    .classBuilder()
    .ep(commonParams)
    .m(function (Command, cs, config, o) {
    return [getEndpointPlugin(config, Command.getEndpointParameterInstructions())];
})
    .s("ChimeMessagingService", "BatchCreateChannelMembership", {})
    .n("ChimeSDKMessagingClient", "BatchCreateChannelMembershipCommand")
    .sc(BatchCreateChannelMembership)
    .build() {
}
